import { replaceBrowserSearchParams } from '@utils/replaceBrowserSearchParams';

export const LISTING_PAGE_QUERY = 'page';

export const getListingPageFromQuery = (page: string | string[] | undefined): number => {
  const raw = Array.isArray(page) ? page[0] : page;
  const parsed = parseInt(raw || '1', 10);
  if (Number.isNaN(parsed) || parsed < 1) return 1;
  return parsed;
};

export const buildListingPageHref = (asPath: string, targetPage: number): string => {
  const [pathname, queryString = ''] = asPath.split('?');
  const params = new URLSearchParams(queryString);
  params.set(LISTING_PAGE_QUERY, String(Math.max(1, targetPage)));
  return `${pathname}?${params.toString()}`;
};

/** Prefer browser URL so filter params stay in sync after history.replaceState updates. */
export const getListingAsPath = (routerAsPath?: string): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.pathname}${window.location.search}`;
  }
  return routerAsPath || '/';
};

export const getListingPageFromBrowser = (): number => {
  if (typeof window === 'undefined') return 1;
  return getListingPageFromQuery(new URLSearchParams(window.location.search).get(LISTING_PAGE_QUERY) || undefined);
};

/** Updates page query without Next Router navigation (avoids scroll-to-top on Next 16). */
export const setListingPageInUrl = (page: number) => {
  if (typeof window === 'undefined') return;

  const urlParams = new URLSearchParams(window.location.search);
  if (page <= 1) {
    urlParams.delete(LISTING_PAGE_QUERY);
  } else {
    urlParams.set(LISTING_PAGE_QUERY, String(page));
  }

  replaceBrowserSearchParams(urlParams);
};
